var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "title" },
    [
      _c("span", { staticClass: "title-t" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm.help ? _c("help-tips", { attrs: { helpText: _vm.help } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }